import type { ActivityCompletionMetrics } from "@/app/integration/contracts";
import type { CurriculumAudioPlayer } from "@/features/audio";

import { DailyRoutinePlayer } from "./DailyRoutinePlayer";
import { SchoolScenarioPlayer } from "./SchoolScenarioPlayer";
import { SchoolbagPlayer } from "./SchoolbagPlayer";
import { getHabitsLevelBinding } from "./bindings";
import type {
  HabitsAudioReplayRequest
} from "./player-contracts";
import "./habits-player.css";

export interface HabitsLevelPlayerProps {
  readonly audioPlayer: CurriculumAudioPlayer;
  readonly levelId: string;
  readonly onAudioReplay: (request: HabitsAudioReplayRequest) => void;
  readonly onComplete?: (metrics: ActivityCompletionMetrics) => void;
  readonly onReplay?: (levelId: string) => void;
  readonly reducedMotion?: boolean;
}

export function HabitsLevelPlayer({
  audioPlayer,
  levelId,
  onAudioReplay,
  onComplete,
  onReplay,
  reducedMotion = false
}: HabitsLevelPlayerProps) {
  const binding = getHabitsLevelBinding(levelId);

  if (binding === undefined) {
    return (
      <section className="habits-player habits-player--unavailable" role="alert">
        <h2>这一关还没准备好</h2>
        <p>请返回活动地图，选一个已经准备好的活动。</p>
      </section>
    );
  }

  const commonProps = {
    audioPlayer,
    onAudioReplay,
    onComplete,
    onReplay,
    reducedMotion
  };

  switch (binding.activityType) {
    case "daily-routine":
      return (
        <DailyRoutinePlayer
          {...commonProps}
          binding={binding}
          key={binding.level.id}
        />
      );
    case "pack-schoolbag":
      return (
        <SchoolbagPlayer
          {...commonProps}
          binding={binding}
          key={binding.level.id}
        />
      );
    case "school-scenarios":
      return (
        <SchoolScenarioPlayer
          {...commonProps}
          binding={binding}
          key={binding.level.id}
        />
      );
  }
}
